













































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { Inject } from 'inversify-props'
import type { ModeloDeEtiquetaServiceAdapter } from '@/usecases'
import {
	EstacaoDeImpressao,
	JobDeImpressaoNoHistorico,
	situacoesDoJobDeImpressao,
	StatusDaFatiaDeImpressao,
} from '@/models/EstacaoDeImpressao'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'

@Component
export default class DialogoDeHistoricoDeImpressaoNaFila extends Vue {
	@Inject('ModeloDeEtiquetaServiceAdapter')
	private modeloDeEtiquetaService!: ModeloDeEtiquetaServiceAdapter

	readonly LIMITE = 20
	readonly INTERVALO_DE_ATUALIZACAO_MS = 5000

	aberto = false
	carregando = false
	reimprimindoId: string | null = null
	historico: JobDeImpressaoNoHistorico[] = []
	lojaId = ''
	estacoes: EstacaoDeImpressao[] = []
	private timerDeAtualizacao: number | null = null

	mostrar(lojaId: string, estacoes: EstacaoDeImpressao[]) {
		this.lojaId = lojaId
		this.estacoes = estacoes
		this.historico = []
		this.aberto = true
		this.carregar()
	}

	async carregar() {
		if (!this.lojaId) return
		try {
			this.carregando = true
			this.historico = await this.modeloDeEtiquetaService.buscarHistoricoDeImpressao(this.lojaId, this.LIMITE)
		} catch (error: any) {
			AlertModule.setError(error)
		} finally {
			this.carregando = false
			this.agendarAtualizacaoSeHouverLoteEmAndamento()
		}
	}

	@Watch('aberto')
	aoAbrirOuFechar(aberto: boolean) {
		if (!aberto) {
			this.pararAtualizacao()
		}
	}

	beforeDestroy() {
		this.pararAtualizacao()
	}

	private agendarAtualizacaoSeHouverLoteEmAndamento() {
		this.pararAtualizacao()
		if (!this.aberto || !this.temLoteEmAndamento()) return
		this.timerDeAtualizacao = window.setTimeout(
			() => this.atualizarEmSilencio(), this.INTERVALO_DE_ATUALIZACAO_MS)
	}

	private async atualizarEmSilencio() {
		if (!this.aberto || !this.lojaId) return
		try {
			this.historico = await this.modeloDeEtiquetaService.buscarHistoricoDeImpressao(this.lojaId, this.LIMITE)
		} catch (error: any) {
			// Falha aqui não vira alerta: a atualização é de fundo e repetiria o aviso a cada 5s.
		}
		this.agendarAtualizacaoSeHouverLoteEmAndamento()
	}

	private pararAtualizacao() {
		if (this.timerDeAtualizacao === null) return
		window.clearTimeout(this.timerDeAtualizacao)
		this.timerDeAtualizacao = null
	}

	private temLoteEmAndamento(): boolean {
		return this.historico.some(job => job.status === 'ENFILEIRANDO'
			|| job.fatias.some(fatia => fatia.status === 'ENFILEIRADA'))
	}

	async reimprimir(job: JobDeImpressaoNoHistorico) {
		try {
			this.reimprimindoId = job.id
			const resultado = await this.modeloDeEtiquetaService.reimprimirJob(job.id)
			AlertModule.setSuccess(
				`Reenviado para impressão: ${resultado.quantidadeDeEtiquetas} etiqueta(s) em ${resultado.totalDeFatias} parte(s).`,
			)
			await this.carregar()
			this.$emit('reimprimiu', resultado)
		} catch (error: any) {
			AlertModule.setError(error)
		} finally {
			this.reimprimindoId = null
		}
	}

	nomeDaEstacao(estacaoId: string): string {
		return this.estacoes.find(estacao => estacao.id === estacaoId)?.nome || 'Impressora removida'
	}

	situacao(job: JobDeImpressaoNoHistorico) {
		return situacoesDoJobDeImpressao[job.status] || { rotulo: job.status, cor: 'grey' }
	}

	progresso(job: JobDeImpressaoNoHistorico): string {
		if (job.status === 'CONCLUIDO') {
			return `${job.quantidadeDeEtiquetas} etiqueta(s)`
		}
		if (job.quantidadeConfirmada === 0) {
			return `${job.quantidadeDeEtiquetas} etiqueta(s) · nenhuma confirmada ainda`
		}
		const faltando = job.quantidadeDeEtiquetas - job.quantidadeConfirmada
		return `imprimiu ${job.quantidadeConfirmada} de ${job.quantidadeDeEtiquetas}`
			+ (faltando > 0 ? ` · ${faltando} não saíram` : '')
	}

	mostraDetalhe(job: JobDeImpressaoNoHistorico): boolean {
		return job.status === 'PARCIAL' || job.status === 'FALHOU'
	}

	corDaFatia(status: StatusDaFatiaDeImpressao): string {
		if (status === 'IMPRESSA' || status === 'ENTREGUE_AO_SPOOL') return 'success'
		if (status === 'FALHOU' || status === 'DESCARTADA') return 'error'
		return 'grey'
	}

	formatarDataHora(iso: string): string {
		return new Date(iso).toLocaleString('pt-BR')
	}
}
